"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolEchainCalculatorFactory = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const RolEchainWithAdapterLinkCalculator_1 = require("./RolEchainWithAdapterLinkCalculator");
const RolEchainWithAutoglideLinkCalculator_1 = require("./RolEchainWithAutoglideLinkCalculator");
const RolEchainWithModifiedLinkCalculator_1 = require("./RolEchainWithModifiedLinkCalculator");
class RolEchainCalculatorFactory {
    static getCalculator(rolEchain) {
        const { type } = (0, echain_shared_articles_1.asTypedRolEchainUnion)(rolEchain);
        switch (type) {
            case 'RolEchainWithAdapterLink':
            case 'RolEchainWithoutAdditionalLink':
                return new RolEchainWithAdapterLinkCalculator_1.RolEchainWithAdapterLinkCalculator();
            case 'RolEchainWithAutoglideLink':
                return new RolEchainWithAutoglideLinkCalculator_1.RolEchainWithAutoglideLinkCalculator();
            case 'RolEchainWithModifiedLink':
                return new RolEchainWithModifiedLinkCalculator_1.RolEchainWithModifiedLinkCalculator();
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
}
exports.RolEchainCalculatorFactory = RolEchainCalculatorFactory;
//# sourceMappingURL=RolEchainCalculatorFactory.js.map